import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { AppLogo } from '../../../components/common';
import AdminNotificationsBell from './AdminNotificationsBell';

export default function AdminBrand() {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Box sx={{ height: 52, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <AppLogo variant="navbar" to="/admin/dashboard" />
        <AdminNotificationsBell />
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, pl: 0.5 }}>
        Admin dashboard
      </Typography>
    </Box>
  );
}
